import useSWR from 'swr';

import { BillableHoursTypeConfig } from '~/data/rewarding/types';
import { fetchFromOldApi } from '~/services/Http';

export const getBillableHoursData = (
  employeeId: number | string,
  employmentId: number | string,
): Promise<BillableHoursTypeConfig[]> => {
  return fetchFromOldApi(
    `/json/employee/${employeeId}/employment/${employmentId}/billablehours`,
  ).then((r) => r.json());
};

type PropsType = {
  employeeId: number;
  employmentId: number | string;
};
export const useGetBillableHoursData = (props: PropsType) => {
  const { employeeId, employmentId } = props;

  const { data, isLoading, error } = useSWR(
    ['billableHoursData', employeeId, employmentId],
    () => getBillableHoursData(employeeId, employmentId),
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
